
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1703"}},[_c('path',{attrs:{"data-name":"Rectangle 2408","fill":"none","d":"M0 0h25v20H0z"}}),_c('path',{attrs:{"data-name":"Path 1054","d":"M22 18h-1.462V2.006c0-1.107-.9-1-2-1s-2-.1-2 1V18H16L12.938 1.834c-.215-1.128-1.075-.854-2.16-.648s-1.985.267-1.772 1.392l2.93 15.421H8.459V2.006c0-1.107-.895-1-2-1s-2-.1-2 1V18H3a1 1 0 000 2h19a1 1 0 000-2z","fill":"#3c3c3c"}})])])
          )
        }
      }
    